<template>
  <div class="job-list">
    <div v-if="jobList.length > 0">
      <div class="jl-item" v-for="(e,i) in jobList" :key="i">
        <div class="sign" v-if="e.is_top_match && matchValue == 'match_degree'">TOP MATCH</div>
        <!-- 公司、职位名称 -->
        <div class="conmpany-info">
          <el-row :gutter="12">
            <el-col :span="2" class="leapin-text-center">
              <img v-if="e.company_logo_url != null && e.company_logo_url" class="logo" :src="e.company_logo_url" />
              <div v-else class="logo leapin-logo-avatar">{{ e.company_name[0] }}</div>
            </el-col>
            <el-col :span="22">
              <div class="ci-type">
                <div v-if="e.publish_time != '' && e.publish_time != undefined " class="leapin-tags leapin-blue">
                  {{ e.publish_time }}
                </div>
              </div>
              <div class="ci-name" @click="showDetail(e.id)">
                {{ e.name }}
              </div>
              <div class="ci-company">
                {{ e.company_name }} 
                <!-- / <span v-if="e.company_stage != null">{{ companyStageList.find(item => item.value == e.company_stage).name }}</span> -->
              </div>
              <!-- 职位要求 -->
              <div class="company-icons">
                <el-row :gutter="120">
                  <el-col :span="6"><div class="ci-item"><img :src="comLocation" /> {{ getEmptyBack(e.location) }}</div></el-col>
                  <el-col :span="6"><div class="ci-item"><img :src="comJobtype" />{{ jobTypeList.find(item => item.value == e.job_type).name }}</div></el-col>
                  <el-col :span="6"><div class="ci-item"><img :src="comWorktype" />{{ e.office_type < 3 ? officeTypeList.find(item => item.value == e.office_type).name : 'Onsite' }}</div></el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <div class="buttons">
            <div 
              :class="[
                'leapin-light-huge-button',
                'ob-small',
                e.mark_type == 1 ? 'marked' : ''
              ]"
              @click="markPosition(e.id,e.mark_type)">
              <img :src="star" />
            </div>
            <div class="leapin-primary-huge-button ob-small" @click="openOriginUrl(e.id, e.origin_url)">
              <img :src="linkAirWhite" /> APPLY 
            </div>
          </div>
        </div>

        <!-- 操作按钮 -->
        <!-- <div class="operating-button">
          <div class="text">
            <p>Skills associated with the job</p>
            <span v-if="e.skills != null">{{ e.skills.join(', ') }}</span>
            <span v-else>---</span>
          </div>
        </div> -->
      </div>
    </div>
    <Empty v-else />
    <!-- 职位详情 -->
    <el-dialog :append-to-body="true" :top="'80px'" :visible.sync="positionDetailVisible" width="960px">
      <job-detail :detailData="detailData" @refreshJobList="refreshJobList"></job-detail>
    </el-dialog>
  </div>
</template>

<script>
import {
  jobsMark,
  getJobDetail
} from '@/services/jobs'
export default {
  components: {
    JobDetail: () => import('@/views/Jobs/detail.vue')
  },
  props: {
    jobList: {
      type: Array,
      default: []
    },
    maxNum: {
      type: Number,
      default: 10
    },
    onlyShow: {
      type: Boolean,
      default: false
    },
    matchValue: {
      type: String,
      default: ''
    }
  },
  name: 'listItem',
  data() {
    return {
      jobTypeList: [
        { value: 0, name: 'Full-time' },
        { value: 1, name: 'Part-time' },
        { value: 2, name: 'Internship' },
        { value: 3, name: 'Contract' },
        { value: 4, name: 'Temporary' },
        { value: 5, name: 'Other' },
      ],
      companyStageList: [
        { value: 0, name: 'Early Stage' },
        { value: 1, name: 'Growth Stage' },
        { value: 2, name: 'Late Stage' },
        { value: 3, name: 'Pubilc Company' },
      ],
      officeTypeList: [
        { value: 0, name: 'Onsite' },
        { value: 1, name: 'Remote' },
        { value: 2, name: 'Hybrid' },
      ],
      positionDetailVisible: false,
      linkAirWhite: require('@/assets/svgs/link-air-white.svg'),
      comLocation: require('@/assets/svgs/location-company.svg'),
      comJobtype: require('@/assets/svgs/jobtype-company.svg'),
      comExp: require('@/assets/svgs/exp-company.svg'),
      comSalary: require('@/assets/svgs/salary-company.svg'),
      comWorktype: require('@/assets/svgs/worktype-company.svg'),
      comLevel: require('@/assets/svgs/level-company.svg'),
      dislike: require('@/assets/svgs/dislike.svg'),
      star: require('@/assets/svgs/star.svg'),
      detailData: {} // 职位详情
    }
  },
  mounted () {
    
  },
  methods: {
    // 显示职位详情
    showDetail(id) {
      if (this.onlyShow) {
        return
      }
      getJobDetail({},id).then(res => {
        if (res.code === 0) {
          this.detailData = res.data
          this.positionDetailVisible = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    refreshJobList () {
      this.$emit('refreshJobList')
    },
    openOriginUrl(id, url) {
      this.markPosition(id, 2)
      window.open(url)
    },
    // 标记职位
    markPosition(id,type) {
      let parmas = {
        job_id: id,
        mark_type: type == 1 ? 4 : 1, // 0-recommend 1-like 2-applied 3-collected 4-unlike
      }
      jobsMark(parmas).then(res => {
        if (res.code === 0) {
          this.$message.success(res.message)
          this.$emit("refreshJobList")
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.job-list {
  display: flex;
  flex-direction: column;
  gap: 20px 0;
  .jl-item {
    background: #fcfbfc;
    padding: 32px;
    margin-bottom: 10px;
    position: relative;
    .sign {
      color: #000;
      font-size: 11px;
      font-weight: 400;
      display: flex;
      padding: 6px 14px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 0px 0px 16px;
      background: var(--Color, #FFDA52);
      position: absolute;
      top: 0px;
      right: 0px;
    }
    .marked {
      background: #e9e8fa !important
    } 
    .conmpany-info {
      // padding-bottom: 32px;
      // border-bottom: 1px solid #E6E8F0;
      position: relative;
      .buttons {
        display: flex;
        gap: 0 10px;
        position: absolute;
        right: 0px;
        top: 40px;
        .ob-small {
          height: 24px !important;
          width: fit-content !important;
          img {
            width: 14px;
            height: 14px;
          }
        }
      }
      .logo {
        width: 48px;
        height: 48px;
        object-fit: cover;
        //border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;
      }
      .ci-type {
        display: flex;
        gap: 16px;
        margin-bottom: 8px;
      }
      .ci-name {
        cursor: pointer;
        color: #1166dd;
        font-family: "PingFang SC";
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 12px;
        letter-spacing: 0.5px;
        width: fit-content;
      }
      .ci-company {
        color: #000;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        span {
          color: #999;
        }
      }
    }
    .company-icons {
      padding-top: 12px;
      display: flex;
      flex-direction: column;
      gap: 16px 0;
      .ci-item {
        display: flex;
        gap: 0 8px;
        align-items: center;
        img {
          width: 16px;
          height: 16px;
        }
      }
    }
    // .operating-button {
    //   margin-top: 32px;
    //   display: flex;
    //   justify-content: space-between;
    //   justify-items: center;
    //   .text {
    //     color: #999;
    //     font-family: "PingFang SC";
    //     font-size: 13px;
    //     font-weight: 400;
    //     p {
    //       color: #000;
    //       margin-bottom: 4px;
    //     }
    //   }

    // }
  }
}
</style>
<style lang="scss">
.job-list {
  .el-dialog__body{
    padding: 0px;
    border-radius: 30px
  }
  .el-dialog__header {
    padding: 0px;
  }
  .el-dialog {
    border-radius: 30px;
  }
  .el-dialog__headerbtn {
    right: -40px;
    top: -10px;
    font-size: 28px;
    transition: transform 0.5s ease; /* 平滑旋转效果 */
    transform: rotate(0deg); /* 初始旋转角度 */
  }
  .el-dialog__headerbtn:hover {
    transform: rotate(180deg); /* 鼠标悬停时旋转180度 */
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
  }
}
</style>
